import './Square.css';
const Square=(props)=>{    
    return (
        <div className={`square ${props.winnerSquares.indexOf(props.id)>-1?'win':props.theme.current}-square`} 
            id={props.id} key={props.id} onClick={(item)=>props.onClick(item.target.id)}>
            <p className={`square-data ${props.theme.current}-square-data`}>{props.data}</p>
        </div>
    )
}
export default Square